import React from 'react'
import { Button, Grid } from '@material-ui/core';

import BlogCard from './BlogCard'
import './Blog.css'

const blogs = [
    {
        id: 1,
        title: 'The Future of Web Application Security: Trends and Innovations You Cant Afford to Ignore',
        date: 'May 18, 2023',
        img: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhzmcAS8tK7DL_VXCwGJ-K2h9t0r8Z3ZFuTb3d10uUSZn7-XLzNsBLMvUE0JMOGwK1BnxrK6yoKM-LlagSOcdjh2MQbxkM1J3SAbopzezzU5YMH6eySYo766q0HM-7eT7tqOqAirxwI5PnuAMkHlvvRGDnpTEkeVdK0QRM6yzUMuV0J0B_eFrhYpnGf/w400-h266/web%20application%20security.jpg',
        url: 'https://www.mddevelopers.tk/2023/05/web-application-security.html'
    },
    {
        id: 2,
        title: 'AI Chat Google: Enhancing Conversations with Artificial Intelligence',
        date: 'May 11, 2023',
        img: 'https://images.tmcnet.com/tmc/misc/articles/image/2019-dec/7518617546-AdobeStock_gears_automation_SUPERSIZE.jpg',
        url: 'https://www.mddevelopers.tk/2023/05/AI-Chat-Google.html',
    },
    {
        id: 3,
        title: 'Exploring the World of Artificial Intelligence with OpenAI',
        date: ' January 06, 2023 ',
        img: 'https://miro.medium.com/max/1400/1*qPao_uBbHlzHIzOL7ejI8w.png',
        url: 'https://www.mddevelopers.tk/2023/01/open-ai.html'
    },

]

function Blog() {
    return (
        <div className="blog" id="blog">
            <h1>Recent Posts</h1>

            <Grid container direction="row" justify="center" alignItems="center" className="blogs_container">
                {blogs.map(blog => (
                    <BlogCard 
                        title={blog.title}
                        date={blog.date}
                        img={blog.img}
                        url={blog.url}
                    />
                ))}
            </Grid>

            <a href="https://www.mddevelopers.tk/" target="_blank" rel="noreferrer">
                <Button className="btn draw-border">Visit Blog</Button>
            </a>
        </div>
    )
}

export default Blog
